import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Checkbox } from "@/components/ui/checkbox";

function RoleAccessTable({
  allPermissions,
  allFeatures,
  checkedItems,
  setCheckedItems,
  setUpdatePermissionData,
  onDirty,
}) {
  const handleCheckboxChange = (permissionId) => {
    setCheckedItems((prev) => {
      const newCheckedItems = {
        ...prev,
        [permissionId]: !prev[permissionId],
      };

      const isChecked = newCheckedItems[permissionId];

      setUpdatePermissionData((prevUpdate) => {
        let newPermissions;

        if (isChecked) {
          // add permission if not already added
          if (!prevUpdate.permissions.find((p) => p.id === permissionId)) {
            const permissionToAdd = allPermissions.find(
              (p) => p.id === permissionId
            );
            newPermissions = [...prevUpdate.permissions, permissionToAdd];
          } else {
            newPermissions = prevUpdate.permissions;
          }
        } else {
          // remove permission unchecked
          newPermissions = prevUpdate.permissions.filter(
            (p) => p.id !== permissionId
          );
        }

        return {
          ...prevUpdate,
          permissions: newPermissions,
        };
      });

      return newCheckedItems;
    });
    if (onDirty) onDirty();
  };

  return (
    // <Table className="w-full overflow-auto">
    //   <TableHeader className="bg-cblack6 !border-none rounded">
    //     <TableRow>
    //       <TableHead className="text-cgreen min-w-[200px]">Features</TableHead>
    //       <TableHead className="text-cgreen ">Permissions</TableHead>
    //     </TableRow>
    //   </TableHeader>

    //   <TableBody className="!bg-red-800 overflow-x-auto" >
    //     {allFeatures?.map((feature) => {
    //       const featurePermissions = allPermissions?.filter(
    //         (perm) => perm?.feature_id === feature.id
    //       );
    //       return (
    //         <TableRow key={feature.id}>
    //           <TableCell className="font-medium w-[200px]">
    //             {feature?.feature_name}
    //           </TableCell>
    //           <TableCell className="flex gap-5 items-center pr-4">
    //             {featurePermissions?.map((perm) => (
    //               <div key={perm?.id} className="flex items-center space-x-2">
    //                 <Checkbox
    //                   id={`perm-${perm?.id}`}
    //                   checked={!!checkedItems[perm.id]}
    //                   onCheckedChange={() => handleCheckboxChange(perm?.id)}
    //                 />
    //                 <label
    //                   htmlFor={`perm-${perm?.id}`}
    //                   className="cursor-pointer flex flex-shrink-0"
    //                 >
    //                   {perm?.permission_name}
    //                 </label>
    //               </div>
    //             ))}
    //           </TableCell>
    //         </TableRow>
    //       );
    //     })}
    //   </TableBody>
    // </Table>
    <div className="w-full min-w-[500px] overflow-auto">
      {/* Header Row */}
      <div className="flex bg-cblack6 text-cgreen font-semibold border-b border-cgray rounded px-4 py-2 min-w-[600px]">
        <div className="min-w-[240px]">Features</div>
        <div className="flex-1">Permissions</div>
      </div>

      {/* Body */}
      <div className="">
        {allFeatures?.map((feature) => {
          const featurePermissions = allPermissions?.filter(
            (perm) => perm?.feature_id === feature.id
          );

          return (
            <div
              key={feature.id}
              className="flex border-b items-start px-4 py-2 min-w-[600px]"
            >
              {/* Feature Name */}
              <div className="min-w-[240px] text-cwhite2 font-normal">
                {feature.feature_name}
              </div>

              {/* Permissions */}
              <div className="flex flex-wrap text-cwhite3 gap-5 items-center flex-1 pr-4">
                {featurePermissions?.length > 0 ? (
                  featurePermissions.map((perm) => (
                    <div key={perm?.id} className="flex items-center space-x-2 py-2">
                      <Checkbox
                        id={`perm-${perm?.id}`}
                        checked={!!checkedItems[perm.id]}
                        onCheckedChange={() => handleCheckboxChange(perm?.id)}
                      />
                      <label
                        htmlFor={`perm-${perm?.id}`}
                        className="cursor-pointer flex text-sm flex-shrink-0"
                      >
                        {perm?.permission_name}
                      </label>
                    </div>
                  ))
                ) : (
                  <span className="text-xs text-cwhite3 italic">No permissions</span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default RoleAccessTable;
